import React from "react";
import { Link } from "react-router-dom";
import "./App.css";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />
        <div
          className="ow-inner ow-404-inner"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: "1.25rem",
            marginTop: "2rem",
          }}
        >
          <p className="ow-eyebrow">404</p>
          <h1 className="ow-page-title">{t("error")}</h1>
          <p className="ow-page-body">{t("error-2")}</p>
          <div style={{ paddingBottom: "20rem" }}>
            <Link
              to="/"
              className="ow-btn ow-btn-primary"
              style={{ marginTop: "2rem" }}
            >
              <Home size={15} strokeWidth={2.5} />
              {t("return")}
            </Link>
          </div>
        </div>
        <SiteFooter />
      </div>
    </>
  );
}
